import DiscountTag from '@/components/hotels/DiscountTag';
import CheckIcon from '@/components/icons/CheckIcon';
import { currencies } from "@/constants/currencies";
import { useUserStore } from '@/core/stores/user';
import useProvider1Store from '@/core/stores/provider1';
import useToast from '@/hooks/useToast';
import { NewProvider1RoomDetails, Provider1RateBasis } from '@/types/provider1';
import { calculateHotelPrices } from '@/utils/calculateHotelPrices';
import { faTag, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from 'js-cookie';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import RateCancellationInfo from '../../NewComponents/CancellationPolicies';
import Button from '@/components/ui/Button';
interface Props {
    room: NewProvider1RoomDetails,
    duration: number
    mainRoomIndex: number;
    totalPassenger: number;
    loadMore?: boolean;
    roomIndex: number;
    minMaxChildrenAges: number[] | undefined;
    setActiveRoomDetail: Dispatch<SetStateAction<{
        mainRoomIndex: number;
        roomIndex: number;
    } | null>>
    activeRoomDetail: {
        mainRoomIndex: number;
        roomIndex: number;
    } | null
}

export const RoomCard = ({ setActiveRoomDetail, activeRoomDetail, duration, minMaxChildrenAges, totalPassenger, room, mainRoomIndex, roomIndex, }: Props) => {

    const showingRate = room.minPrice
    const { errorToast } = useToast()
    const { selectedRooms, toggleSelectedRoom } = useProvider1Store()

    const [showRateModal, setShowRateModal] = useState(false)

    const [rateKey, setRateKey] = useState("");
    const [rate, setRate] = useState<Provider1RateBasis>();

    const [error, setError] = useState('')



    const handleOptionChange = (rate: Provider1RateBasis) => {

        const selectedRoomsHolder = [...selectedRooms.filter(
            (selected) => selected.roomTypeId === room.roomTypeId,
        )];
        if (selectedRoomsHolder?.length > 0 && selectedRoomsHolder.length >= Number(room.rateBases?.[0].leftToSell)) {
            setError(`This room option has no availability left for booking.`)
            errorToast(`This room option has no availability left for booking.`)
            return
        }

        if (!!rate?.minStay && Number(rate.minStay) > duration) {
            setError(`Your stay duration is too short. The minimum stay for this room is ${rate.minStay} days.`)
            errorToast(`Your stay duration is too short. The minimum stay for this room is ${rate.minStay} days.`)
            return
        }
        if (selectedRooms.length > 0 && !!selectedRooms.find(item => item.roomIndex === mainRoomIndex) && !selectedRoom) {
            setError(`You can't select multiple items for each room section`)
            errorToast(`You can't select multiple items for each room section`)
            return
        }
        if (selectedRoom && (selectedRoom.selectedRate.allocationDetails !== rate.allocationDetails)) {
            setError(`You can't select multiple items for each room section`)
            errorToast(`You can't select multiple items for each room section`)
            return
        }



        setRate(c => (c === rate ? undefined : rate));
        setActiveRoomDetail({ mainRoomIndex: mainRoomIndex, roomIndex: roomIndex })
        setRateKey((prev) => {
            if (prev === rate.allocationDetails) {
                return "";
            }
            return rate.allocationDetails;
        });
    };


    const handleMinus = (rateArg?: Provider1RateBasis) => {
        if (rateArg) {
            toggleSelectedRoom({ ...room, selectedRate: rateArg }, rateArg?.allocationDetails, roomIndex)
        }
        // removeRoomsByRoomCode(room.code);
        setRateKey('')
        setRate(undefined)
        setError('')
    };

    const [showNoRateSelectedHint, setShowNoRateSelectedHint] = useState(false);

    const handlePlus = () => {
        if (!rate) {
            setShowNoRateSelectedHint(true)
            setTimeout(() => {
                setShowNoRateSelectedHint(false)
            }, 3000)
            return
        }
        rate && toggleSelectedRoom({ ...room, selectedRate: rate },
            rate?.allocationDetails,
            mainRoomIndex)
        setShowRateModal(false)
        // innerWidth > 700 && onClose()
    };

    const selectedRoom = selectedRooms.find(item => item.roomTypeId === room.roomTypeId && (item.roomIndex === mainRoomIndex))

    const currency = Cookies.get('currency') || 'USD'

    const rateOffer = room.rateBases[0]


    const roomIsNotActive = activeRoomDetail?.mainRoomIndex === mainRoomIndex && activeRoomDetail.roomIndex !== roomIndex


    useEffect(() => {
        if (roomIsNotActive) {
            setRate(undefined)
            setRateKey('')
        }
    }, [roomIsNotActive])

    const offerAmount = rateOffer.offers ? calculateHotelPrices(rateOffer.price, rateOffer.offers.charge, duration) : null
    return (
        <>
            <div className={`${selectedRoom ? (selectedRoom.orderStatus === 'unsuccessful' || totalPassenger > Number(room.maxOccupancy) ? 'border-rose-300 hover:!border-rose-500' : 'border-secondary-500') : 'border-gray-300'} 
            flex border rounded-3xl shadow-md
                             hover:border-secondary-300 hover:shadow   transition-all duration-200 flex-col w-full px-4 py-4 col-span-4 
                             lg:col-span-2 relative overflow-hidden pb-3 cursor-pointer`}>
                <div onClick={() => {
                    if (totalPassenger > Number(room.maxOccupancy)) {
                        errorToast('Your travelers exceed the maximum capacity for this room.')
                        return
                    }
                    if (minMaxChildrenAges && minMaxChildrenAges[1] < Number(room.minChildAge)) {
                        errorToast(`  This room has a minimum child age limit of ${room.minChildAge}, which exceeds the age of the travelers you selected.`)
                        return
                    }
                    if (minMaxChildrenAges && minMaxChildrenAges[0] > Number(room.maxChildAge)) {
                        errorToast(` This room has a maximum child age limit of ${room.maxChildAge}, which is less than the age of the travelers you selected.`)
                        return
                    }
                    // setActiveRoomDetail({ mainRoomIndex: mainRoomIndex, roomIndex: roomIndex })
                }}
                    className="grow flex flex-col"
                >
                    <div className="flex grow flex-col relative">
                        {selectedRoom && selectedRoom.orderStatus === 'unsuccessful' ?
                            <div className='py-1 w-fit absolute top-0 right-0 shadow-sm px-2 flex items-center gap-1 bg-pastel-red rounded-full text-main-800 text-sm font-normal'>
                                <CheckIcon className='w-4' />

                                <span>Not Available</span>
                            </div>
                            : selectedRoom &&
                            <div className='py-1 w-fit absolute z-30 top-0 right-0 shadow-sm px-2 flex items-center gap-1 bg-pastel-green rounded-full text-gray-800 text-sm font-normal'>
                                <CheckIcon className='w-4' />

                                <span>Selected</span>
                            </div>
                        }
                        <div className="flex flex-col grow">
                            <p className="pb-1 text-sm font-semibold capitalize text-gray-800 line-clamp-2">
                                {room.name?.toLowerCase()}
                            </p>
                            <div className={`${totalPassenger > Number(room.maxOccupancy) ? 'text-rose-500' : 'text-neutral-700'} flex items-center gap-2 mt-1`}>
                                <FontAwesomeIcon icon={faUser} className='text-sm' />
                                <p className={`text-xs`}><span className='font-semibold '>
                                    Max Occupancy:</span>
                                    {room.maxOccupancy}
                                </p>
                            </div>
                            {totalPassenger > Number(room.maxOccupancy) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    Your travelers exceed the maximum capacity for this room.
                                </p>}
                            {minMaxChildrenAges && minMaxChildrenAges[0] > Number(room.maxChildAge) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    This room has a maximum child age limit of {room.maxChildAge}, which is less than the age of the travelers you selected..
                                </p>}
                            {minMaxChildrenAges && minMaxChildrenAges[1] < Number(room.minChildAge) &&
                                <p className='text-xs  mt-2 text-red-500 font-normal'>
                                    This room has a minimum child age limit of {room.minChildAge}, which exceeds the age age of the travelers you selected.
                                </p>}
                            {selectedRoom?.orderStatus === 'unsuccessful' &&
                                <p className='text-xs  mt-2 text-red-500'>
                                    The room option you selected is not currently available for booking, please try to remove it and select another one.
                                </p>}
                            <div className="flex flex-col gap-2 mt-3 max-h-64 overflow-y-auto grow">
                                {room.rateBases.map((rate, index: number) => {
                                    const ratePrice = rate.price;

                                    const isSelectedOption = !!selectedRoom && (rate.allocationDetails === selectedRoom?.selectedRate.allocationDetails)
                                    const offerAmount = rate.offers ? calculateHotelPrices(rate.price, rate.offers.charge, duration) : null
                                    return (
                                        <label

                                            htmlFor={index + "room-card-mobile"}
                                            key={index + "room-card-mobile"}
                                            className='h-fit '
                                        >
                                            <div
                                                onClick={() => {
                                                    handleOptionChange(rate)
                                                }}
                                                className={`${showNoRateSelectedHint ? 'border-rose-500' : ''} p-4 grid-cols-[1fr,_auto] grid bg-white
                                         ${((rate.allocationDetails === rateKey) || isSelectedOption) ? 'border-2 border-secondary-500 ' : ''}
                                             rounded-2xl border-2  h-fit relative transition-colors duration-200 md:hover:border-indigo-300 cursor-pointer`}
                                            >

                                                <div>
                                                    {
                                                        (!!offerAmount && offerAmount.discountPercent > 0) &&
                                                        <DiscountTag discountPercent={offerAmount.discountPercent} className='mb-1 !left-auto !right-2' />
                                                    }
                                                    <div className='flex items-center gap-3 mb-1'>
                                                        <button onClick={() => {
                                                            if ((isSelectedOption)) {
                                                                handleMinus(rate)
                                                            }
                                                        }}
                                                            className={`
                                                        ${(isSelectedOption) ? 'hover:border-main-500 hover:bg-main-50 transition-colors duration-200' : ''}
                                                        group  transition-colors duration-300 border border-secondary-500 rounded-full 
                                                                 bg-secondary-50 flex items-center justify-center size-5`}>
                                                            {((rate.allocationDetails === rateKey) || isSelectedOption) &&
                                                                <div className={`${(isSelectedOption) ? 'group-hover:bg-main-500 transition-colors duration-200' : ''} bg-secondary-500 rounded-full size-3`}>

                                                                </div>}
                                                        </button>
                                                        <p className='text-sm font-semibold text-gray-900'>
                                                            {rate.boardType}
                                                        </p>

                                                    </div>
                                                    <RateCancellationInfo roomName={room.name?.toLowerCase()} withDescription rate={rate} />

                                                </div>
                                                <div className='flex items-end gap-2'>

                                                    {(!!offerAmount && offerAmount.discountPercent > 0) &&
                                                        <span className=' text-rose-500 line-through  font-semibold'>
                                                            {currencies[currency]}{(offerAmount.originalPrice).toFixed(0)}
                                                        </span>}


                                                    <div className='flex items-center gap-2'>
                                                        {!!rate.minStay && Number(rate.minStay) > 0 && <span className='text-xs font-normal text-neutral-600'>
                                                            Min stay: {rate.minStay} night(s)
                                                        </span>}
                                                        <p className="font-bold text-gray-900">
                                                            {currencies[currency]}
                                                            {ratePrice}
                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </label>
                                    );
                                })}
                            </div>

                            <div>
                                <Button
                                    onClick={handlePlus}
                                    color='secondary'
                                    className={`${!rate ? '!opacity-20' : ''} w-full mt-2`}
                                >
                                    Add
                                </Button>
                            </div>
                            <div className="flex flex-col gap-2">

                                {/* <div className="text-gray-500 text-xs flex flex-row gap-1 items-center">
                                    <FontAwesomeIcon icon={faUser} />
                                    <span className="text-neutral-800 ps-1">Sleeps:</span>
                                    <p className="text-neutral-800 font-normal">
                                        <span>{roomDetails?.maxAdults} </span>
                                        <span>{roomDetails?.maxAdults > 1 ? "Adults, " : "Adult"}</span>
                                        {roomDetails?.maxChildren > 0 &&
                                            <>
                                                <span> {roomDetails?.maxChildren} </span>
                                                <span>{roomDetails?.maxChildren > 1 ? "Children" : "child"}</span>
                                            </>
                                        }
                                    </p>
                                </div> */}

                            </div>
                            <div className="mb-2 line-clamp-1 hidden flex-row flex-wrap gap-2">

                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </>
    );
};
